import React from "react";
import * as Globals from '../modules/Globals';
import CBCard from "../components/CBCard";
import useLanguage from '../hooks/uselanguage';
import TitleHeader from "../components/TitleHeader";

const Agenda = () => {
    const lang = (useLanguage().language === 'pt')?1:2;

    //var cont = 1;

    return (
        <>
            <TitleHeader />
            {
            Globals.tdata.agenda.map(
                item => {
                    if( lang === item.lang )
                        return (
                            <CBCard 
                                title={item.title}
                                descr={item.description}
                                img={item.images}
                                item={item}
                                isagenda={true}
                                lang={lang}
                                /*reverse={(cont++%2)===0}*/
                            />
                        )
                }
            )
            }
        </>
    );
};

export default Agenda;